var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "base-card",
        [
          _c(
            "v-card-text",
            [
              _c(
                "v-form",
                { ref: "form" },
                [
                  _c(
                    "base-card",
                    [
                      _c(
                        "v-row",
                        [
                          _c("v-col", { attrs: { cols: "12", sm: "12" } }, [
                            _c("h3", [_vm._v("Configuración Formatos DIAN")]),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "6" } },
                            [
                              _c("div", [_vm._v("Empresa contable:")]),
                              _c("v-text-field", {
                                staticStyle: { "max-width": "50%" },
                                attrs: {
                                  dense: "",
                                  "prepend-inner-icon": "mdi mdi-domain",
                                  disabled: "",
                                },
                                model: {
                                  value: _vm.accountingCompanies,
                                  callback: function ($$v) {
                                    _vm.accountingCompanies = $$v
                                  },
                                  expression: "accountingCompanies",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "text-end mt-5",
                              attrs: { cols: "12", sm: "6" },
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "white--text px-8 py-4",
                                  attrs: { color: "rgb(204 33 40)" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.copyFormats()
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    " Importar configuraciones anteriores "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        [
                          _c("v-col", { attrs: { cols: "12", sm: "12" } }, [
                            _c(
                              "div",
                              { staticClass: "line-text" },
                              [
                                _c(
                                  "v-card-text",
                                  [
                                    _c(
                                      "v-row",
                                      [
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "12", sm: "3" } },
                                          [
                                            _c("div", [_vm._v("Año:")]),
                                            _c("v-select", {
                                              attrs: {
                                                items: _vm.years,
                                                "item-text": "text",
                                                "item-value": "value",
                                                "prepend-inner-icon":
                                                  "mdi mdi-calendar-range",
                                                required: "",
                                                dense: "",
                                                outlined: "",
                                              },
                                              model: {
                                                value: _vm.dataFilter.year,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.dataFilter,
                                                    "year",
                                                    $$v
                                                  )
                                                },
                                                expression: "dataFilter.year",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "12", sm: "6" } },
                                          [
                                            _c("div", [_vm._v("Formato:")]),
                                            _c("v-select", {
                                              attrs: {
                                                items: _vm.formats,
                                                "item-text": "description",
                                                "item-value": "id",
                                                "prepend-inner-icon":
                                                  "mdi mdi-format-align-justify",
                                                required: "",
                                                dense: "",
                                                outlined: "",
                                              },
                                              model: {
                                                value: _vm.dataFilter.format,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.dataFilter,
                                                    "format",
                                                    $$v
                                                  )
                                                },
                                                expression: "dataFilter.format",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-col",
                                          {
                                            staticClass: "mt-6",
                                            attrs: { cols: "12", sm: "3" },
                                          },
                                          [
                                            _c(
                                              "v-btn",
                                              {
                                                staticClass: "white--text",
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  color: "rgb(99 92 92)",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.openModalTaxes()
                                                  },
                                                },
                                              },
                                              [_vm._v(" Configurar impuestos ")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-row",
                                      [
                                        _c(
                                          "v-col",
                                          {
                                            staticClass: "d-flex",
                                            attrs: { cols: "12", md: "9" },
                                          },
                                          [
                                            _c(
                                              "p",
                                              { staticClass: "tam-p mt-1" },
                                              [
                                                _vm._v(
                                                  " Unificar clientes con datos incompletos en cuantías menores: "
                                                ),
                                              ]
                                            ),
                                            _vm._v("     "),
                                            _c("v-select", {
                                              staticStyle: {
                                                "max-width": "fit-content",
                                              },
                                              attrs: {
                                                items: _vm.optionsMiniorAccount,
                                                "item-text": "text",
                                                "item-value": "value",
                                                required: "",
                                                outlined: "",
                                                dense: "",
                                                "hide-details": "",
                                              },
                                              model: {
                                                value:
                                                  _vm.dataCredentials
                                                    .appliesGroupingByLackData,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.dataCredentials,
                                                    "appliesGroupingByLackData",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "dataCredentials.appliesGroupingByLackData",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-col",
                                          {
                                            staticClass:
                                              "d-flex justify-end align-start",
                                            attrs: { cols: "12", md: "3" },
                                          },
                                          [
                                            _c(
                                              "v-btn",
                                              {
                                                staticClass:
                                                  "white--text border-button",
                                                attrs: {
                                                  color: "rgb(204 33 40)",
                                                  disabled:
                                                    this.disableBottomSave,
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.saveConfigImport()
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "v-icon",
                                                  { attrs: { left: "" } },
                                                  [
                                                    _vm._v(
                                                      "mdi-content-save-edit-outline"
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" Guardar "),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm.showAlert
                                  ? _c(
                                      "v-row",
                                      {
                                        staticClass: "my-4",
                                        attrs: { justify: "center" },
                                      },
                                      [
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "12", sm: "6" } },
                                          [
                                            _c(
                                              "v-alert",
                                              {
                                                staticClass: "my-4",
                                                attrs: {
                                                  type: _vm.alertType,
                                                  dense: "",
                                                  outlined: "",
                                                  border: "left",
                                                  "colored-border": "",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(_vm.alertMessage) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "v-card-text",
                        { staticClass: "mt-5 line-text" },
                        [
                          _c(
                            "v-toolbar",
                            { attrs: { flat: "", dense: "" } },
                            [
                              _c(
                                "v-toolbar-title",
                                { staticClass: "d-flex" },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "border-button",
                                      attrs: {
                                        outlined: "",
                                        color: "rgb(204 33 40)",
                                      },
                                      on: { click: _vm.openConceptModal },
                                    },
                                    [
                                      _c("v-icon", { attrs: { left: "" } }, [
                                        _vm._v(
                                          "mdi mdi-plus-box-multiple-outline"
                                        ),
                                      ]),
                                      _vm._v(" Agregar concepto "),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-row",
                                { attrs: { justify: "center" } },
                                [
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "my-4",
                                      attrs: { cols: "12", sm: "8" },
                                    },
                                    [
                                      _vm.showAlertTable
                                        ? _c(
                                            "v-alert",
                                            {
                                              staticClass: "my-4",
                                              attrs: {
                                                type: _vm.alertTypeTable,
                                                dense: "",
                                                outlined: "",
                                                border: "left",
                                                "colored-border": "",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.alertMessageTable
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c("v-data-table", {
                            staticClass: "elevation-1 mt-5",
                            attrs: {
                              headers: _vm.headers,
                              items: _vm.dataTable,
                              search: _vm.search,
                              loading: _vm.loadingTable,
                              "loading-text": "Cargando Importaciones...",
                              "no-data-text":
                                "No se han añadido conceptos aún ...",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: `item.conceptDescription2`,
                                  fn: function ({ item }) {
                                    return [
                                      _c("div", { staticClass: "text-left" }, [
                                        _vm._v(
                                          " " +
                                            _vm._s(item.conceptDescription2) +
                                            " "
                                        ),
                                      ]),
                                    ]
                                  },
                                },
                                {
                                  key: `item.startAccount`,
                                  fn: function ({ item }) {
                                    return [
                                      _c("v-select", {
                                        attrs: {
                                          items:
                                            _vm.filterAccountingAccountStart,
                                          "item-text": "text",
                                          "item-value": "value",
                                          required: "",
                                          dense: "",
                                          outlined: "",
                                          filter: "",
                                          "search-input": "",
                                          "hide-details": "",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "prepend-item",
                                              fn: function () {
                                                return [
                                                  _c(
                                                    "v-list-item",
                                                    [
                                                      _c(
                                                        "v-list-item-content",
                                                        [
                                                          _c(
                                                            "v-list-item-title",
                                                            [
                                                              _c(
                                                                "v-text-field",
                                                                {
                                                                  staticClass:
                                                                    "search-field",
                                                                  attrs: {
                                                                    placeholder:
                                                                      "Buscar",
                                                                    "prepend-inner-icon":
                                                                      "mdi-magnify",
                                                                    "hide-details":
                                                                      "",
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm.searchAccountingAccountStart,
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.searchAccountingAccountStart =
                                                                          $$v
                                                                      },
                                                                    expression:
                                                                      "searchAccountingAccountStart",
                                                                  },
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                        model: {
                                          value: item.startAccount,
                                          callback: function ($$v) {
                                            _vm.$set(item, "startAccount", $$v)
                                          },
                                          expression: "item.startAccount",
                                        },
                                      }),
                                    ]
                                  },
                                },
                                {
                                  key: `item.endAccount`,
                                  fn: function ({ item }) {
                                    return [
                                      _c("v-select", {
                                        attrs: {
                                          items: _vm.filterAccountingAccountEnd,
                                          "item-text": "text",
                                          "item-value": "value",
                                          required: "",
                                          dense: "",
                                          outlined: "",
                                          filter: "",
                                          "search-input": "",
                                          "hide-details": "",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "prepend-item",
                                              fn: function () {
                                                return [
                                                  _c(
                                                    "v-list-item",
                                                    [
                                                      _c(
                                                        "v-list-item-content",
                                                        [
                                                          _c(
                                                            "v-list-item-title",
                                                            [
                                                              _c(
                                                                "v-text-field",
                                                                {
                                                                  staticClass:
                                                                    "search-field",
                                                                  attrs: {
                                                                    placeholder:
                                                                      "Buscar",
                                                                    "prepend-inner-icon":
                                                                      "mdi-magnify",
                                                                    "hide-details":
                                                                      "",
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm.searchAccountingAccountEnd,
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.searchAccountingAccountEnd =
                                                                          $$v
                                                                      },
                                                                    expression:
                                                                      "searchAccountingAccountEnd",
                                                                  },
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                        model: {
                                          value: item.endAccount,
                                          callback: function ($$v) {
                                            _vm.$set(item, "endAccount", $$v)
                                          },
                                          expression: "item.endAccount",
                                        },
                                      }),
                                    ]
                                  },
                                },
                                {
                                  key: `item.formatColumnId`,
                                  fn: function ({ item }) {
                                    return [
                                      _c("v-select", {
                                        attrs: {
                                          items: _vm.filterReportValueColumn,
                                          "item-text": "text",
                                          "item-value": "value",
                                          required: "",
                                          dense: "",
                                          outlined: "",
                                          filter: "",
                                          "search-input": "",
                                          "hide-details": "",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "prepend-item",
                                              fn: function () {
                                                return [
                                                  _c(
                                                    "v-list-item",
                                                    [
                                                      _c(
                                                        "v-list-item-content",
                                                        [
                                                          _c(
                                                            "v-list-item-title",
                                                            [
                                                              _c(
                                                                "v-text-field",
                                                                {
                                                                  staticClass:
                                                                    "search-field",
                                                                  attrs: {
                                                                    placeholder:
                                                                      "Buscar",
                                                                    "prepend-inner-icon":
                                                                      "mdi-magnify",
                                                                    "hide-details":
                                                                      "",
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm.searchReportValueColumn,
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.searchReportValueColumn =
                                                                          $$v
                                                                      },
                                                                    expression:
                                                                      "searchReportValueColumn",
                                                                  },
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                        model: {
                                          value: item.formatColumnId,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              item,
                                              "formatColumnId",
                                              $$v
                                            )
                                          },
                                          expression: "item.formatColumnId",
                                        },
                                      }),
                                    ]
                                  },
                                },
                                {
                                  key: `item.appliesTopAmount`,
                                  fn: function ({ item }) {
                                    return [
                                      _c("v-select", {
                                        attrs: {
                                          items: _vm.optionsMiniorAccount,
                                          "item-text": "text",
                                          "item-value": "value",
                                          required: "",
                                          outlined: "",
                                          dense: "",
                                          "hide-details": "",
                                        },
                                        model: {
                                          value: item.appliesTopAmount,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              item,
                                              "appliesTopAmount",
                                              $$v
                                            )
                                          },
                                          expression: "item.appliesTopAmount",
                                        },
                                      }),
                                    ]
                                  },
                                },
                                {
                                  key: `item.topAmount`,
                                  fn: function ({ item }) {
                                    return [
                                      _c("v-text-field", {
                                        attrs: {
                                          dense: "",
                                          outlined: "",
                                          "hide-details": "",
                                          type: "number",
                                          disabled: !item.appliesTopAmount,
                                        },
                                        model: {
                                          value: item.topAmount,
                                          callback: function ($$v) {
                                            _vm.$set(item, "topAmount", $$v)
                                          },
                                          expression: "item.topAmount",
                                        },
                                      }),
                                    ]
                                  },
                                },
                                {
                                  key: `item.calculationTypeId`,
                                  fn: function ({ item }) {
                                    return [
                                      _c("v-select", {
                                        staticClass: "origin-value-select",
                                        attrs: {
                                          items: _vm.filterOriginValue,
                                          "item-text": "description",
                                          "item-value": "calculationTypeId",
                                          required: "",
                                          dense: "",
                                          outlined: "",
                                          filter: "",
                                          "search-input": "",
                                          "hide-details": "",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "prepend-item",
                                              fn: function () {
                                                return [
                                                  _c(
                                                    "v-list-item",
                                                    [
                                                      _c(
                                                        "v-list-item-content",
                                                        [
                                                          _c(
                                                            "v-list-item-title",
                                                            [
                                                              _c(
                                                                "v-text-field",
                                                                {
                                                                  staticClass:
                                                                    "search-field",
                                                                  attrs: {
                                                                    placeholder:
                                                                      "Buscar",
                                                                    "prepend-inner-icon":
                                                                      "mdi-magnify",
                                                                    "hide-details":
                                                                      "",
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm.searchOriginValue,
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.searchOriginValue =
                                                                          $$v
                                                                      },
                                                                    expression:
                                                                      "searchOriginValue",
                                                                  },
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                        model: {
                                          value: item.calculationTypeId,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              item,
                                              "calculationTypeId",
                                              $$v
                                            )
                                          },
                                          expression: "item.calculationTypeId",
                                        },
                                      }),
                                    ]
                                  },
                                },
                                {
                                  key: `item.ivaMayorValorCosto`,
                                  fn: function ({ item }) {
                                    return [
                                      _c("v-select", {
                                        attrs: {
                                          items: _vm.optionsMiniorAccount,
                                          "item-text": "text",
                                          "item-value": "value",
                                          required: "",
                                          outlined: "",
                                          dense: "",
                                          "hide-details": "",
                                        },
                                        model: {
                                          value: item.ivaMayorValorCosto,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              item,
                                              "ivaMayorValorCosto",
                                              $$v
                                            )
                                          },
                                          expression: "item.ivaMayorValorCosto",
                                        },
                                      }),
                                    ]
                                  },
                                },
                                {
                                  key: `item.hconceptsCfg`,
                                  fn: function ({ item, index }) {
                                    return [
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass: "border-button",
                                          attrs: {
                                            outlined: "",
                                            color: "rgb(204 33 40)",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.addConceptAccounting(
                                                item,
                                                index
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("v-icon", [
                                            _vm._v("mdi mdi-tab-plus"),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                                {
                                  key: `item.delete`,
                                  fn: function ({ item }) {
                                    return [
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass: "border-button",
                                          attrs: {
                                            outlined: "",
                                            color: "rgb(204 33 40)",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.deleteConcept(item)
                                            },
                                          },
                                        },
                                        [
                                          _c("v-icon", [
                                            _vm._v("mdi mdi-trash-can-outline"),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-overlay",
        { attrs: { value: _vm.loading, absolute: "", opacity: "0.6" } },
        [
          _c("v-progress-circular", {
            attrs: { indeterminate: "", size: "64", color: "rgb(204 33 40)" },
          }),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "500" },
          model: {
            value: _vm.showModalExist,
            callback: function ($$v) {
              _vm.showModalExist = $$v
            },
            expression: "showModalExist",
          },
        },
        [
          _c(
            "v-card",
            { staticClass: "pa-6" },
            [
              _c("v-card-text", { staticClass: "text-center" }, [
                _c("p", { staticClass: "mb-4 font-weight-medium" }, [
                  _vm._v(
                    " Se requiere que cuente con cuentas para generar algun tipo de confirguracion. "
                  ),
                ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "500" },
          model: {
            value: _vm.showModalConcept,
            callback: function ($$v) {
              _vm.showModalConcept = $$v
            },
            expression: "showModalConcept",
          },
        },
        [
          _c(
            "v-card",
            { staticClass: "pa-6" },
            [
              _c("v-card-title", { staticClass: "just-cen" }, [
                _c("h4", [_vm._v("Seleccionar concepto")]),
              ]),
              _c(
                "v-card-text",
                { staticClass: "text-center mt-3" },
                [
                  _c("v-select", {
                    attrs: {
                      items: _vm.filterAccountingConcept,
                      "item-text": "text",
                      "item-value": "value",
                      required: "",
                      dense: "",
                      outlined: "",
                      filter: "",
                      "search-input": "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "prepend-item",
                        fn: function () {
                          return [
                            _c(
                              "v-list-item",
                              [
                                _c(
                                  "v-list-item-content",
                                  [
                                    _c(
                                      "v-list-item-title",
                                      [
                                        _c("v-text-field", {
                                          staticClass: "search-field",
                                          attrs: {
                                            placeholder: "Buscar",
                                            "prepend-inner-icon": "mdi-magnify",
                                            "hide-details": "",
                                          },
                                          model: {
                                            value: _vm.searchAccountingConcept,
                                            callback: function ($$v) {
                                              _vm.searchAccountingConcept = $$v
                                            },
                                            expression:
                                              "searchAccountingConcept",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                    model: {
                      value: _vm.conceptItem,
                      callback: function ($$v) {
                        _vm.conceptItem = $$v
                      },
                      expression: "conceptItem",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-card-actions",
                { staticClass: "justify-end" },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { text: "" },
                      on: {
                        click: function ($event) {
                          _vm.showModalConcept = false
                        },
                      },
                    },
                    [_vm._v(" Cancelar ")]
                  ),
                  _c(
                    "v-btn",
                    {
                      staticClass: "white--text",
                      attrs: { color: "rgb(204 33 40)" },
                      on: { click: _vm.addConceptToTable },
                    },
                    [_vm._v(" Agregar ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "500" },
          model: {
            value: _vm.showModalConceptAccounting,
            callback: function ($$v) {
              _vm.showModalConceptAccounting = $$v
            },
            expression: "showModalConceptAccounting",
          },
        },
        [
          _c(
            "v-card",
            { staticClass: "pa-6" },
            [
              _c("v-card-title", { staticClass: "just-cen" }, [
                _c("h4", [_vm._v("Agregar Conceptos Contables")]),
              ]),
              _c(
                "v-card-text",
                { staticClass: "text-center mt-3" },
                [
                  _c("v-select", {
                    attrs: {
                      items: _vm.filterHConcept,
                      "item-text": "text",
                      "item-value": "value",
                      required: "",
                      dense: "",
                      outlined: "",
                      filter: "",
                      "search-input": "",
                      multiple: "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "prepend-item",
                        fn: function () {
                          return [
                            _c(
                              "v-list-item",
                              [
                                _c(
                                  "v-list-item-content",
                                  [
                                    _c(
                                      "v-list-item-title",
                                      [
                                        _c("v-text-field", {
                                          staticClass: "search-field",
                                          attrs: {
                                            placeholder: "Buscar",
                                            "prepend-inner-icon": "mdi-magnify",
                                            "hide-details": "",
                                          },
                                          model: {
                                            value: _vm.searchHConcept,
                                            callback: function ($$v) {
                                              _vm.searchHConcept = $$v
                                            },
                                            expression: "searchHConcept",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                    model: {
                      value: _vm.conceptAccountingItem,
                      callback: function ($$v) {
                        _vm.conceptAccountingItem = $$v
                      },
                      expression: "conceptAccountingItem",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-card-actions",
                { staticClass: "justify-end" },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { text: "" },
                      on: {
                        click: function ($event) {
                          _vm.showModalConceptAccounting = false
                        },
                      },
                    },
                    [_vm._v(" Cancelar ")]
                  ),
                  _c(
                    "v-btn",
                    {
                      staticClass: "white--text",
                      attrs: { color: "rgb(204 33 40)" },
                      on: { click: _vm.addConceptAccountingToTable },
                    },
                    [_vm._v(" Agregar ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "600px", persistent: "" },
          model: {
            value: _vm.showModalCopyFormat,
            callback: function ($$v) {
              _vm.showModalCopyFormat = $$v
            },
            expression: "showModalCopyFormat",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "d-flex align-center" },
                [
                  _c("span", { staticClass: "text-h6" }, [
                    _vm._v("Copiar Configuración"),
                  ]),
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "" },
                      on: {
                        click: function ($event) {
                          _vm.showModalCopyFormat = false
                        },
                      },
                    },
                    [_c("v-icon", [_vm._v("mdi-close")])],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12", md: "6" } },
                        [
                          _c(
                            "div",
                            { staticClass: "mb-1 font-weight-medium" },
                            [_vm._v("Año origen")]
                          ),
                          _c("v-select", {
                            attrs: {
                              items: _vm.years,
                              "item-text": "text",
                              "item-value": "value",
                              "prepend-inner-icon": "mdi-calendar-range",
                              dense: "",
                              outlined: "",
                            },
                            model: {
                              value: _vm.dataCopy.from,
                              callback: function ($$v) {
                                _vm.$set(_vm.dataCopy, "from", $$v)
                              },
                              expression: "dataCopy.from",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12", md: "6" } },
                        [
                          _c(
                            "div",
                            { staticClass: "mb-1 font-weight-medium" },
                            [_vm._v("Año destino")]
                          ),
                          _c("v-select", {
                            attrs: {
                              items: _vm.yearsTo,
                              "item-text": "text",
                              "item-value": "value",
                              "prepend-inner-icon": "mdi-calendar-range",
                              dense: "",
                              outlined: "",
                              disabled: this.disabledTo,
                            },
                            model: {
                              value: _vm.dataCopy.to,
                              callback: function ($$v) {
                                _vm.$set(_vm.dataCopy, "to", $$v)
                              },
                              expression: "dataCopy.to",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    { staticClass: "mt-2" },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "div",
                            { staticClass: "mb-1 font-weight-medium" },
                            [_vm._v("Formatos a copiar")]
                          ),
                          _c("v-select", {
                            staticClass: "max-height-select",
                            attrs: {
                              items: _vm.formats,
                              "item-text": "description",
                              "item-value": "id",
                              "prepend-inner-icon": "mdi-format-align-justify",
                              dense: "",
                              outlined: "",
                              multiple: "",
                              chips: "",
                            },
                            model: {
                              value: _vm.dataCopy.formats,
                              callback: function ($$v) {
                                _vm.$set(_vm.dataCopy, "formats", $$v)
                              },
                              expression: "dataCopy.formats",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-actions",
                { staticClass: "justify-end" },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { text: "" },
                      on: {
                        click: function ($event) {
                          _vm.showModalCopyFormat = false
                        },
                      },
                    },
                    [_vm._v(" Cancelar ")]
                  ),
                  _c(
                    "v-btn",
                    {
                      staticClass: "white--text",
                      attrs: { color: "rgb(204 33 40)" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.copyFormatsYear.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c("v-icon", { attrs: { left: "" } }, [
                        _vm._v("mdi-content-copy"),
                      ]),
                      _vm._v(" Importar "),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "800px", persistent: "" },
          model: {
            value: _vm.showModalTaxes,
            callback: function ($$v) {
              _vm.showModalTaxes = $$v
            },
            expression: "showModalTaxes",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "d-flex align-center" },
                [
                  _c("span", [_vm._v("CONFIGURAR IVA MAYOR VALOR DEL COSTO")]),
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.closeModalTax.apply(null, arguments)
                        },
                      },
                    },
                    [_c("v-icon", [_vm._v("mdi-close")])],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-text",
                [
                  _c(
                    "div",
                    { staticClass: "dis-div mt-3" },
                    [
                      _c(
                        "v-row",
                        { attrs: { justify: "center" } },
                        [
                          _c("v-text-field", {
                            staticClass: "r-search",
                            attrs: {
                              "append-icon": "mdi-magnify",
                              "hide-details": "",
                              label: "Buscar Impuesto",
                              "single-line": "",
                            },
                            model: {
                              value: _vm.searchModalTaxes,
                              callback: function ($$v) {
                                _vm.searchModalTaxes = $$v
                              },
                              expression: "searchModalTaxes",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    {
                      staticClass: "permiso-lista mt-3",
                      attrs: { justify: "start" },
                    },
                    _vm._l(_vm.filteredTaxes, function (p) {
                      return _c(
                        "v-col",
                        {
                          key: p.HTaxCode,
                          attrs: { cols: "12", sm: "6", md: "6" },
                        },
                        [
                          _c(
                            "v-card",
                            {
                              staticClass: "permiso-card",
                              attrs: { elevation: "3" },
                            },
                            [
                              _c(
                                "v-card-text",
                                { staticClass: "d-flex align-center bcard" },
                                [
                                  _c("v-checkbox", {
                                    staticStyle: { "margin-top": "inherit" },
                                    attrs: {
                                      value: p.id,
                                      "hide-details": "",
                                      color: "rgb(204 33 40)",
                                    },
                                    model: {
                                      value: _vm.selectedTaxes,
                                      callback: function ($$v) {
                                        _vm.selectedTaxes = $$v
                                      },
                                      expression: "selectedTaxes",
                                    },
                                  }),
                                  _c("div", { staticClass: "div-b-c" }, [
                                    _c("span", [
                                      _vm._v(_vm._s(p.percentage) + "%"),
                                    ]),
                                    _c("p", { staticClass: "tam-p" }, [
                                      _vm._v(_vm._s(p.description)),
                                    ]),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-actions",
                { staticClass: "justify-end" },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { text: "" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.closeModalTax.apply(null, arguments)
                        },
                      },
                    },
                    [_vm._v(" Cancelar ")]
                  ),
                  _c(
                    "v-btn",
                    {
                      staticClass: "white--text",
                      attrs: { color: "rgb(204 33 40)" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.saveConfigTaxes.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c("v-icon", { attrs: { left: "" } }, [
                        _vm._v("mdi mdi-content-save-check-outline"),
                      ]),
                      _vm._v(" Guardar "),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "450px", persistent: "" },
          model: {
            value: _vm.showModalAlert,
            callback: function ($$v) {
              _vm.showModalAlert = $$v
            },
            expression: "showModalAlert",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "headline" },
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "" },
                      on: {
                        click: function ($event) {
                          _vm.showModalAlert = false
                        },
                      },
                    },
                    [_c("v-icon", [_vm._v("mdi-close")])],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-card-text",
                { staticClass: "text-center pa-6" },
                [
                  _c(
                    "v-icon",
                    {
                      staticClass: "icon-warning",
                      attrs: { color: "error", size: "56" },
                    },
                    [_vm._v(" mdi-alert-circle-outline ")]
                  ),
                  _c(
                    "div",
                    { staticClass: "mt-4" },
                    [
                      _c(
                        "h3",
                        { staticClass: "subtitle-1 font-weight-bold mb-2" },
                        [
                          _vm._v(
                            " ¿Estás seguro de que deseas cambiar la configuración actual? "
                          ),
                        ]
                      ),
                      _c(
                        "v-alert",
                        {
                          staticClass: "text-left mb-0",
                          attrs: { dense: "", text: "", type: "warning" },
                        },
                        [
                          _vm._v(
                            " Los cambios que no hayas guardado se perderán. "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    {
                      staticClass: "mt-5",
                      attrs: { justify: "center", "no-gutters": "" },
                    },
                    [
                      _c(
                        "v-col",
                        { staticClass: "pa-1", attrs: { cols: "12", sm: "6" } },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "white--text",
                              attrs: { block: "", color: "error" },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.confirmChangeConfiguration.apply(
                                    null,
                                    arguments
                                  )
                                },
                              },
                            },
                            [
                              _c("v-icon", { attrs: { left: "" } }, [
                                _vm._v("mdi-check"),
                              ]),
                              _vm._v(" Sí, cambiar "),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { staticClass: "pa-1", attrs: { cols: "12", sm: "6" } },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                block: "",
                                outlined: "",
                                color: "grey darken-1",
                              },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.cancelChangeConfiguration.apply(
                                    null,
                                    arguments
                                  )
                                },
                              },
                            },
                            [
                              _c("v-icon", { attrs: { left: "" } }, [
                                _vm._v("mdi-close"),
                              ]),
                              _vm._v(" Cancelar "),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }